<template>
  <div class="sidemain">
    <el-menu :default-active="activetab" :active="activetab" class="el-menu-vertical-demo" :router="true" @select="tabactive" :collapse="isCollapse">
      <template v-for="(item, index) in menutotal">
        <el-menu-item v-if="item.children.length===0" :key="index" :index="item.path">
          <i class="iconfont" :class="item.icon" style="margin-right:5px"></i>
          {{ item.name }}
        </el-menu-item>
        <template v-else>
          <el-submenu  :key="item.id" :index="index + ''">
            <!-- 一级菜单 -->
            <template slot="title">
              <!-- <svg-icon :iconClass="item.meta.icon" :className="item.meta.icon" /> -->
              <i class="iconfont" :class="item.icon" style="margin-right:5px"></i>
              <span slot="title">{{ item.name }}</span>
            </template>
            <!-- 子级菜单 -->
            <template v-for="(subItem,index1) in item.children">
              <el-menu-item  :key="index1" :index="subItem.path">
                <!-- <i class="iconfont" :class="item.icon"></i> -->
                {{ subItem.name }}
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
      </template>
      
      
      
      <!-- <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-edit"></i> -->
          <!-- <img src="../images/icon1.png" alt class="iconimg" /> -->
          <!-- <span>笔录管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/askmanage" style="padding-left:80px">询问管理</el-menu-item>
          <el-menu-item index="/casemanage" style="padding-left:80px">案由管理</el-menu-item>
          <el-menu-item index="/attest" style="padding-left:80px">取证管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-user"></i>
          <span>用户管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="/role" style="padding-left:80px">角色管理</el-menu-item>
          <el-menu-item index="/user" style="padding-left:80px">用户管理</el-menu-item>
          <el-menu-item index="/dept" style="padding-left:80px">部门管理</el-menu-item>
          <el-menu-item index="/power" style="padding-left:80px">权限管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu> -->
      <!-- <el-menu-item index="/log" active-class="active">
        <i class="el-icon-edit-outline"></i>
        日志管理
      </el-menu-item>-->
      <!-- <el-menu-item index="/person" active-class="active">
        <i class="el-icon-star-off"></i>
        个人中心
      </el-menu-item> -->

      <!-- <el-menu-item index="/unit" active-class="active">
        <i class="el-icon-office-building"></i>
        单位管理
      </el-menu-item>
      <el-menu-item index="/alarm" active-class="active">
        <i class="el-icon-bell"></i>
        告警管理
      </el-menu-item>
      <el-menu-item index="/detail" active-class="active">
        <i class="el-icon-document"></i>
        运行详情
      </el-menu-item>
      <el-menu-item index="/reportlist">
        <i class="el-icon-document-copy"></i>
        运行报告
      </el-menu-item>-->
      <!-- <el-menu-item index="/record">
        <i class="el-icon-menu"></i>
        <router-link to="/record" active-class="active">出入记录</router-link>
      </el-menu-item>
      <el-menu-item index="/statistics">
        <i class="el-icon-menu"></i>
        <router-link to="/statistics" active-class="active">查询统计</router-link>
      </el-menu-item>-->
      <!-- <el-menu-item index="/device" active-class="active">
        <i class="el-icon-monitor"></i>
        设备管理
      </el-menu-item>-->
      <!-- <el-menu-item index="/videoboard">
        <i class="el-icon-menu"></i>
        <router-link to="/videoboard" active-class="active">视频看板</router-link>
      </el-menu-item>-->
      <!-- <el-menu-item index="/user">
        <i class="el-icon-user-solid"></i>
        账号管理
      </el-menu-item>
      <el-menu-item index="/power">
        <i class="el-icon-bell"></i>
        权限管理
      </el-menu-item>
      <el-menu-item index="/log">
        <i class="el-icon-edit-outline"></i>
        日志管理
      </el-menu-item>
      <el-menu-item index="/person">
        <i class="el-icon-user"></i>
        个人中心
      </el-menu-item>-->
    </el-menu>
  </div>
</template>
<script>

export default {
  data () {
    return {
      activetab: localStorage.getItem("activetab"),
      menutotal:[],
      isCollapse: false,
    };
  },


  methods: {
    tabactive (e) {
      // console.log(e);
      localStorage.setItem("activetab", e);
    },
    menulist () {
      if (localStorage.getItem("permissionList") !== 'undefined') {
        var arr = JSON.parse(localStorage.getItem("permissionList")) || [];
        var newarr = [];
        for (var i in arr) {
          if (arr[i].type === "M") {
            newarr.push(arr[i]);
          }
        }
        const tree = [];

// 创建节点的映射表，方便通过id找到对应的节点
const map = {};
newarr.forEach(item => {
  map[item.id] = {
    id: item.id,
    parentId: item.parentId,
    type: item.type,
    name: item.name,
    path: item.path,
    updateTime: item.updateTime,
    children: []
  };
});

// 将每个节点添加到对应父节点的children数组中
newarr.forEach(item => {
  const node = map[item.id];
  if (item.parentId === 0) {
    // 根节点
    tree.push(node);
  } else {
    // 非根节点
    const parent = map[item.parentId];
    parent.children.push(node);
  }
});

 this.menutotal= tree;
      }

      console.log(this.menutotal);
    }
  },
  created () {
    this.menulist();
    // console.log(JSON.parse(localStorage.getItem("menus")));
  }
};
</script>

<style scoped>
.iconimg {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.sidemain {
  padding-top: 20px;
}
.active {
  color: white;
}

.el-menu .is-active {
  background: #3370ff;

  /* background: linear-gradient(90deg, #41bdba 0%, #88d6d4 100%); */
  border-radius: 6px;
  background-size: contain;
  color: white !important;
  /* display: block; */
  width: 100%;
  /* width: 260px !important;
  max-width: 260px !important;
  min-width: 260px !important; */
}

.el-menu-item {
  font-size: 16px;
  text-align: center;
}

.el-aside {
  overflow: inherit;
}
</style>
